import React from 'react';

import { List, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { FieldGroupItemSchema, RetrieveOrderSchema } from '@app/models/orders';

import { ListItem } from '@components/ListItem';
import { Paper } from '@components/Paper';
import { getDisplayAdditionalValue } from '@pages/Processes/data/getDisplayAdditionalValue';

import { getDisplayValueKey } from '../../../../../../data/getDisplayValueKey';

interface IProps {
  item: FieldGroupItemSchema;
  isLoading: boolean;
  orderData?: RetrieveOrderSchema;
}

export const OrderFieldGroup: React.FC<IProps> = ({ item, isLoading, orderData }) => {
  const ordersT = useTranslation(NSKeys.orders);
  const translateOrder = ordersT.t as (key: string) => string;
  const fieldGroupKey = item.data.alias || item.data.uid;
  const fieldGroupData = orderData?.field_groups?.[fieldGroupKey];
  const isVisible = orderData?.$field_groups?.[fieldGroupKey]?.view;

  if (!isVisible) {
    return null;
  }

  return (
    <Paper style={{ padding: '24px 24px' }}>
      <Typography.Title level={3}>{item.data.name}</Typography.Title>
      <List style={{ maxWidth: 600, margin: '20px 0' }} loading={isLoading}>
        {item.data.fields.map((field, i) => (
          <ListItem
            key={`field${i}`}
            title={`${field.name}`}
            description={getDisplayValueKey({
              type: field.type,
              alias: field.alias || field.uid,
              data: fieldGroupData,
            })}
            additionalData={getDisplayAdditionalValue({
              type: field.type,
              alias: field.alias || field.uid,
              data: fieldGroupData,
            })?.map((el) => ({
              title: translateOrder(`tableColumns.${el.title}`),
              description: el.description,
            }))}
          />
        ))}
      </List>
    </Paper>
  );
};
